import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';

/**
*   Interface/model file auto generate for Setting Group
*   Interface for back-end
*   Model for front-end.
*   They are the same!
*/
export interface TypedFaq {
    // Define FAQ interface
    id?: string;
    question?: string;
    answer?: string;
    question_order?: number;
    createdAt?: string; // ISO timestamp
}


type IQuery = TypedFaq & IQueryParams;


/*
* List of all app
*/
export function useGetFaqs(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["faq/fetch_entity_list"],
        queryFn: () => axios.get<TypedFaq[]>(`/faq${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                entities: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: true,
    });
}

export function useGetFaq() {
    return useMutation({
        mutationKey: ['faq/fetch_entity'],
        mutationFn: (id: any) => axios.get<TypedFaq>(`faq/${id}`).then(response => response.data)
    })
}


export function useUpdateFaq() {
    return useMutation({
        mutationKey: ['faq/update_entity'],
        mutationFn: ({ id, ...rest }: TypedFaq) => axios.patch<TypedFaq>(`/faq/${id}`, helpers.cleanEntity(rest)).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['faq/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['faq/fetch_entity'] });
        }
    });
}


export function useCreateFaq() {
    return useMutation({
        mutationKey: ['faq/create_entity'],
        mutationFn: (entity: TypedFaq) => axios.post<TypedFaq>(`/faq`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['faq/fetch_entity_list'] });
        }
    });
}


export function useDeleteFaq() {
    return useMutation({
        mutationKey: ['faq/delete_entity'],
        mutationFn: (id: string) => axios.delete<any>(`/faq/${id}`),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['faq/fetch_entity_list'] });
        }
    });
}

export function useReorderFaq() {
    return useMutation({
        mutationKey: ['faq/batch_reorder'],
        mutationFn: (reorderData: { id: any, question_order: number }[]) => axios.put<any>(`/faq/batch_reorder`, helpers.cleanEntity(reorderData))
    });
}


